import { createLogger } from 'vuex';
import axiosAuth from '../../axiosMain';

async function store(data) {
  let response = await axiosAuth.post('/consumptions', data);
  return response.data.data;
}

export default {
  store,
};
